// extracted by mini-css-extract-plugin
export var container = "_d8-0";
export var infoIcon = "_d8-2";
export var titleRowCol = "_d8-1";